import React from 'react';
import {
  ChevronDown, ChevronUp, AlertTriangle, CheckCircle, Zap,
} from 'lucide-react';

/**
 * Section "Estimation Effacement Électrique" - Mode Pro Élec uniquement.
 * Désactivée si NAF hors plage 4-39.
 */
const EffacementSection = ({
  showEffacement,
  setShowEffacement,
  isNafEntre4et39,
  isPuissanceValide,
  puissanceSouscrite,
  effacement,
  setEffacement,
  puissanceEffacableKW,
  gainCapacite,
  gainNEBEF,
  gainTotalEffacement,
  gainMin,
  gainMax,
  formatNumber,
}) => {
  return (
    <section
      className={`card optional-section effacement-section ${!isNafEntre4et39 ? 'section-disabled' : ''}`}
      data-testid="effacement-section"
    >
      {!isNafEntre4et39 && (
        <div className="section-disabled-overlay" data-testid="effacement-disabled-notice">
          <span className="disabled-badge">Non éligible</span>
          <span className="disabled-reason">Code NAF hors plage 4-39</span>
        </div>
      )}
      <button
        className="section-toggle"
        onClick={() => isNafEntre4et39 && setShowEffacement(!showEffacement)}
        data-testid="effacement-toggle"
        disabled={!isNafEntre4et39}
      >
        <h2 className="section-title">
          <Zap size={20} className="section-icon" />
          Estimation Effacement Électrique <span className="annual-badge">Gains Annuels</span>
        </h2>
        {showEffacement ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </button>
      {showEffacement && isNafEntre4et39 && (
        <div className="optional-content effacement-content">
          <p className="effacement-intro">
            Estimation des gains potentiels via le mécanisme de capacité (Enedis) et NEBEF (valorisation marché spot).
            {!isPuissanceValide && <><br /><strong>⚠️ Veuillez renseigner la puissance souscrite dans la section "Informations Générales".</strong></>}
          </p>

          <div className="form-grid">
            <div className="form-group">
              <label>Puissance souscrite (depuis Informations Générales)</label>
              <div className="readonly-value">
                {puissanceSouscrite > 0 ? `${formatNumber(puissanceSouscrite)} kVA` : 'Non renseignée'}
              </div>
            </div>
            <div className="form-group">
              <label>Taux d'effacement estimé</label>
              <select
                value={effacement.tauxEffacement}
                onChange={(e) => setEffacement({ ...effacement, tauxEffacement: e.target.value })}
                data-testid="taux-effacement-select"
              >
                <option value="20">20 %</option>
                <option value="30">30 %</option>
                <option value="50">50 %</option>
              </select>
              {effacement.tauxEffacement === '50' && (
                <span className="warning-message">
                  <AlertTriangle size={14} />
                  Ce niveau nécessite une forte flexibilité industrielle.
                </span>
              )}
            </div>
          </div>

          {isPuissanceValide && puissanceSouscrite > 0 && (
            <div className="effacement-results">
              <h3 className="results-title">
                <CheckCircle size={18} />
                Résultats de l'estimation
              </h3>

              <div className="results-summary">
                <div className="result-item">
                  <span className="result-label">Puissance souscrite</span>
                  <span className="result-value">{formatNumber(puissanceSouscrite)} kVA</span>
                </div>
                <div className="result-item">
                  <span className="result-label">Taux d'effacement</span>
                  <span className="result-value">{effacement.tauxEffacement} %</span>
                </div>
                <div className="result-item highlight">
                  <span className="result-label">Puissance effaçable</span>
                  <span className="result-value">{formatNumber(puissanceEffacableKW)} kW</span>
                </div>
              </div>

              <div className="gains-grid">
                <div className="gain-card capacite">
                  <span className="gain-label">Gain Capacité</span>
                  <span className="gain-sublabel">Mécanisme Enedis</span>
                  <span className="gain-value">{formatNumber(gainCapacite)} €/an</span>
                </div>
                <div className="gain-card nebef">
                  <span className="gain-label">Gain NEBEF</span>
                  <span className="gain-sublabel">30h × 250 €/MWh</span>
                  <span className="gain-value">{formatNumber(gainNEBEF)} €/an</span>
                </div>
                <div className="gain-card total">
                  <span className="gain-label">Gain Total Estimé</span>
                  <span className="gain-value large">{formatNumber(gainTotalEffacement)} €/an</span>
                  <span className="gain-range">Fourchette : {formatNumber(gainMin)} € – {formatNumber(gainMax)} €</span>
                </div>
              </div>

              <p className="disclaimer">
                Estimation indicative basée sur hypothèses marché 2026. Mécanisme de capacité : 30 000 €/MW/an. NEBEF : 30 heures d'activation, 250 €/MWh.
              </p>
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default EffacementSection;
